import { Stack } from '@mui/material'
import { useWidgetFeedConsumptionChartAll } from 'components/farm-dashboard/hooks/useWidgetFeedConsumptionChartAll'
import { getDatesArray } from 'components/shared/processes'
import { BaseWidget } from '../../baseWidget'
import {
	FeedConsumptionEmptyState,
	FeedConsumptionErrorState,
	FeedConsumptionHeader,
} from '../components'
import { FEED_CONSUMPTION_CHART_WIDGET } from '../constants'
import FeedConsumptionChart from './components/chart/FeedConsumptionChart'

const weekDays = getDatesArray(6)

export const FeedConsumptionLineChart = () => {
	const { fetchData, distributedFood, consumptionFood, isLoading, isError } =
		useWidgetFeedConsumptionChartAll({
			startDate: weekDays.startDate,
			endDate: weekDays.endDate,
		})

	const allDataIsNull =
		fetchData.length > 0 &&
		fetchData.every(
			el => el.distributed_sum === null && el.cleaned_sum === null,
		)
	const isEmptyData =
		fetchData.length === 0 ||
		allDataIsNull ||
		(distributedFood === 0 && consumptionFood === 0)

	return (
		<BaseWidget
			title={FEED_CONSUMPTION_CHART_WIDGET.title}
			path={FEED_CONSUMPTION_CHART_WIDGET.path}
			pathLable={FEED_CONSUMPTION_CHART_WIDGET.pathLabel}
			isLoading={isLoading}
		>
			<Stack
				direction='row'
				justifyContent='space-between'
				alignItems='center'
				mb='12px'
			>
				<FeedConsumptionHeader
					distributedFood={distributedFood}
					consumptionFood={consumptionFood}
				/>
			</Stack>
			{isError ? (
				<FeedConsumptionErrorState />
			) : isEmptyData ? (
				<FeedConsumptionEmptyState />
			) : (
				<FeedConsumptionChart
					height={180}
					timestamp={fetchData.map(p => p.date)}
					distributedFood={fetchData.map(p => p.distributed_sum ?? 0)}
					consumptionFood={fetchData.map(p => p.cleaned_sum ?? 0)}
				/>
			)}
		</BaseWidget>
	)
}
